import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddOrRemoveRolesToUserRequest, UserDTO, UserDetailDTO, AddUserDTO } from '../interfaces/user.interface';
import { environment } from 'src/environments/enviroments';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private httpClient: HttpClient) { }

  /**
   * Metodo para obtener todos los usuarios registrados
   * @returns Listado de usuarios
   */
  getUsers(state: boolean): Observable<Array<UserDTO>>{
    const endpoint = `${environment.apiUrl}/user/${state}`;
    return this.httpClient.get<Array<UserDTO>>(endpoint);
  }

  getUsersByPermission(permission: string): Observable<Array<UserDTO>>{
    const endpoint = `${environment.apiUrl}/user/permission/${permission}`;
    return this.httpClient.get<Array<UserDTO>>(endpoint);
  }
  /**
   * Metodo para registrar a los usuarios
   * @returns Listado de usuarios
   */
  postUsers(user :AddUserDTO): Observable<AddUserDTO>{
    const endpoint = `${environment.apiUrl}/user`;
    return this.httpClient.post<AddUserDTO>(endpoint, user);
  }

  /**
   * Metodo para obtener el detalle de un usuario especifico
   * @param userId id de usuario
   * @returns Entidad del usuario consultado
   */
  getUserById(userId: number): Observable<UserDetailDTO>{
    const endpoint = `${environment.apiUrl}/user/${userId}`;
    return this.httpClient.get<UserDetailDTO>(endpoint);
  }

  /**
   * Metodo para enviar solicitud para remover roles a un usuario
   * @param request Cuerpo de solicitud
   * @returns Respuesta de servicio web
   */
  removeRolesToUser(request: AddOrRemoveRolesToUserRequest): Observable<ActionResponseDTO<number>>{
    const endpoint = `${environment.apiUrl}/user/${request.userId}/roles/revoke`;
    return this.httpClient.put<ActionResponseDTO<number>>(endpoint, request);
  }

    /**
   * Metodo para habilitar la cuenta de usuario
   * @param request Cuerpo de la solicitud
   * @returns Respuesta recibida del servicio web
   */
    enabledToUser(userId: number): Observable<ActionResponseDTO<number>>{
      const endpoint = `${environment.apiUrl}/user/enabledUser/${userId}`;
      return this.httpClient.put<ActionResponseDTO<number>>(endpoint, userId);
    }

        /**
   * Metodo para enviar deshabilitr la cuenta de usuario
   * @param request Cuerpo de la solicitud
   * @returns Respuesta recibida del servicio web
   */
    disabledToUser(userId: number): Observable<ActionResponseDTO<number>>{
      const endpoint = `${environment.apiUrl}/user/disabledUser/${userId}`;
      return this.httpClient.put<ActionResponseDTO<number>>(endpoint, userId);
    }


  /**
   * Metodo para enviar solicitud para asignar roles a un usuario
   * @param request Cuerpo de la solicitud
   * @returns Respuesta recibida del servicio web
   */
  assignRolesToUser(request: AddOrRemoveRolesToUserRequest): Observable<ActionResponseDTO<number>>{
    const endpoint = `${environment.apiUrl}/user/${request.userId}/roles/assign`;
    return this.httpClient.put<ActionResponseDTO<number>>(endpoint, request);
  }
}
